/*@flow*/
import React from 'react';
import RoR from 'vendor/ror';
import ProvideMuiTheme from 'comps/ProvideMuiTheme';
import ReduxStore from 'store';
import client from 'store/apollo';
import * as I from 'immutable';
import universal from 'react-universal-component';
import { ApolloProvider } from '@apollo/react-hooks';
import { StoreContext } from 'redux-react-hook';

// Eager load
import City from 'comps/City';
import MainPage from 'comps/MainPage';
import CommunityResourcesTable from 'comps/Community/Assets/Table';
import LookerDashboard from 'comps/LookerReports/index';
import IFrameDashboard from 'comps/IFrameDashboard';
import OmniDashboard from 'comps/OmniDashboard';


// ----------------- Lazy load ----------------------
const loading = (props: { loadingStyle?: {} }) => {
  const style = props.loadingStyle || { height: '100%' };
  return (
    <div
      data-testid="UniversalLoadingComponent"
      className="text-flex-center"
      style={style}
    >
      <i className="fa fa-spinner fa-spin" />
    </div>
  );
};
// Options
const opts = {
  minDelay: 0,
  loading,
};

// PAGES
const NewPage = universal(import('comps/NewPage'), opts);
const ProjectPage = universal(import('comps/ProjectPage'), opts);
const ProjectPage2 = universal(import('comps/ProjectPage/index2'), opts);
const ProjectIndex = universal(import('comps/ProjectIndex'), opts);

// Etc...
const ProjectMap = universal(import('comps/ProjectMap'), opts);
const Common = universal(import('comps/Common'), opts);
const District = universal(import('comps/District'), opts);
const CompanyEdit = universal(import('comps/Company/Edit'), opts);
const CommunityResources = universal(import('comps/Community/Assets'), opts);
const CommunityResourcesUploadButton = universal(
  import('comps/Community/Assets/Buttons/UploadButton'),
  opts
);
const CommunityResourcesDownloadButton = universal(
  import('comps/Community/Assets/Buttons/DownloadButton'),
  opts
);
const CommunityResourcesAreaFilter = universal(
  import('comps/Community/Assets/Filters/AreaFilter'),
  opts
);
const CreateIssueButton = universal(
  import('comps/StreetscapeAsset/CreateIssueButton'),
  opts
);
const IssueList = universal(import('comps/StreetscapeAsset/IssueList'), opts);
const Scratchpad = universal(import('comps/Scratchpad'), opts);
const CreateEventButton = universal(
  import('comps/Event/CreateEventButton'),
  opts
);
const EventList = universal(import('comps/Event/List'), opts);
const EventRightColumn = universal(
  import('comps/Event/Date/RightColumn'),
  opts
);
const CreateTenantButton = universal(
  import('comps/Unit/CreateTenantButton'),
  opts
);
const TenantList = universal(import('comps/Unit/TenantList'), opts);
const Tables2 = universal(import('comps/Tables2'), opts);
const CommunityMemberSignIn = universal(
  import('comps/Community/MemberSignIn'),
  opts
);
const CommunityUserInvitationAccept = universal(
  import('comps/Community/CommunityUserInvitationAccept'),
  opts
);
const CommunityUserPasswordReset = universal(
  import('comps/Community/CommunityUserPasswordReset'),
  opts
);
const CommunityAccountDashboard = universal(
  import('comps/Community/AccountDashboard'),
  opts
);
const CommunityMemberOnboarding = universal(
  import('comps/Community/Onboarding'),
  opts
);
const CommunityDashboard = universal(import('comps/Community/Dashboard'), opts);
const CommunityLanding = universal(import('comps/Community/Landing'), opts);
const MemberManager = universal(import('comps/Company/MemberManager'), opts);

RoR.registerStore({ ReduxStore });
RoR.register(
  I.Map({
    City,
    NewPage,
    MainPage,
    ProjectPage,
    ProjectPage2,
    ProjectIndex,
    ProjectMap,
    Common,
    District,
    CompanyEdit,
    CommunityResources,
    CommunityResourcesTable,
    CommunityResourcesUploadButton,
    CommunityResourcesDownloadButton,
    CommunityResourcesAreaFilter,
    CreateIssueButton,
    IssueList,
    Scratchpad,
    CreateEventButton,
    EventList,
    EventRightColumn,
    CreateTenantButton,
    TenantList,
    Tables2,
    CommunityMemberSignIn,
    CommunityUserInvitationAccept,
    CommunityUserPasswordReset,
    CommunityAccountDashboard,
    CommunityMemberOnboarding,
    CommunityDashboard,
    CommunityLanding,
    MemberManager,
    LookerDashboard,
    IFrameDashboard,
    OmniDashboard,
  })
    .map((Component) => (props) => (
      <StoreContext.Provider value={ReduxStore}>
        <ApolloProvider client={client}>
          <ProvideMuiTheme>
            {React.createElement(Component, props)}
          </ProvideMuiTheme>
        </ApolloProvider>
      </StoreContext.Provider>
    ))
    .toJS(),
  opts
);
